import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

type Props = {
  fileName: string;
  alt: string;
};

type File = {
  fileName: string;
};
type Node = {
  file: File;
};
const EvolvedImage: React.FC<Props> = ({ fileName, alt }) => {
  const {
    allContentfulAsset: { nodes },
  } = useStaticQuery(graphql`
    {
      allContentfulAsset {
        nodes {
          fluid(maxWidth: 720) {
            ...GatsbyContentfulFluid
          }
          file {
            fileName
          }
        }
      }
    }
  `);

  const image = nodes.find(({ file }: Node) => file.fileName === fileName);
  return <Img fluid={image.fluid} alt={alt} />;
};

export default EvolvedImage;
